import { differenceInYears } from "date-fns/differenceInYears";
import { Patient } from "@/redux/slice/auth/types/Patient";

export const getPatientAge = (patient: Patient): number | null => {
  return patient?.dateOfBirth ? differenceInYears(new Date(), new Date(patient.dateOfBirth)) : null;
};
